import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { AuditLogPage } from "../views";

export const auditRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.superAdmin.auditLog,
    element: <AuditLogPage />,
  },
] as const;
